const isString = (value) => typeof value === "string";
const hasContent = (value) => isString(value) && value.trim().length > 0;

const getHtmlFromTipTapLikeEditor = (editorInstance) => {
  if (!editorInstance) return "";

  if (typeof editorInstance.getHTML === "function") {
    return editorInstance.getHTML() || "";
  }

  if (editorInstance.state?.doc?.toJSON && typeof editorInstance.getHTML === "function") {
    return editorInstance.getHTML() || "";
  }

  return "";
};

const getHtmlFromEditorRef = (editorRef) => {
  if (!editorRef) return "";

  if (editorRef.html && isString(editorRef.html)) return editorRef.html;

  if (editorRef.editor) {
    const html = getHtmlFromTipTapLikeEditor(editorRef.editor);
    if (html) return html;
  }

  if (editorRef.value?.editor) {
    const html = getHtmlFromTipTapLikeEditor(editorRef.value.editor);
    if (html) return html;
  }

  if (editorRef.$refs?.editor) {
    const html = getHtmlFromTipTapLikeEditor(editorRef.$refs.editor);
    if (html) return html;
  }

  if (typeof editorRef.getHTML === "function") {
    return editorRef.getHTML() || "";
  }

  return "";
};

const getHtmlFromElement = (editorElement) => {
  if (!editorElement) return "";
  return editorElement.innerHTML || "";
};

export const extractEditorContent = ({
  html = "",
  editorPayload = null,
  editorRef = null,
  editorElement = null,
} = {}) => {
  if (hasContent(html)) {
    return html;
  }

  const htmlFromElement = getHtmlFromElement(editorElement);
  if (htmlFromElement.trim()) return htmlFromElement;

  const htmlFromRef = getHtmlFromEditorRef(editorRef);
  if (htmlFromRef.trim()) return htmlFromRef;

  if (editorPayload) {
    if (hasContent(editorPayload)) return editorPayload;
    if (hasContent(editorPayload.html)) return editorPayload.html;
  }

  throw new Error(
    "No se pudo extraer contenido HTML del editor. Envia html, editorPayload.html, editorRef o editorElement."
  );
};
